import * as styles from './OpportunityReviewBubbleChart.module.scss';

enum HelpIconPosition {
  LEFT = 'left-help-icon',
  RIGHT = 'right-help-icon',
}

export enum TooltipPosition {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
}

function tooltip(title: string, text: string, position: TooltipPosition): string {
  return `
    <div class='${styles.qd__tooltip} ${position && styles[position]}' role='tooltip'>
      <div class='${styles.qd__title}'>${title}</div>
      <div class='${styles.qd__content}'>${text}</div>
    </div>
  `;
}

function iconLabel(
  iconPosition: HelpIconPosition,
  label: string,
  text: string,
  position: TooltipPosition,
  isExportModalOpen: boolean,
) {
  const displayLabel = `
    <div class='${styles.quadrantLabel}'>
      <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='${iconPosition}'>
        <title id='${iconPosition}'>Help icon</title>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M20.9061 10C20.9061 15.5228 16.4362 20 10.9223 20C5.40837 20 0.938477 15.5228 0.938477 10C0.938477 4.47715 5.40837 0 10.9223 0C16.4362 0 20.9061 4.47715 20.9061 10ZM7.428 4.88971C7.64813 4.70063 7.88769 4.52101 8.14668 4.35084C8.41213 4.18067 8.69702 4.03256 9.00132 3.90651C9.30562 3.78046 9.63583 3.68277 9.99193 3.61344C10.348 3.53781 10.7333 3.5 11.1476 3.5C11.7109 3.5 12.2224 3.57563 12.6821 3.72689C13.1483 3.87815 13.5465 4.09559 13.8767 4.3792C14.2069 4.65651 14.4626 4.9937 14.6439 5.39076C14.8252 5.78782 14.9158 6.23214 14.9158 6.72374C14.9158 7.20273 14.8446 7.6187 14.7022 7.97164C14.5597 8.31828 14.3785 8.6208 14.1583 8.8792C13.9447 9.1376 13.7116 9.36134 13.4591 9.55042C13.2066 9.73949 12.967 9.91912 12.7404 10.0893C12.5138 10.2532 12.3163 10.417 12.148 10.5809C11.9861 10.7384 11.889 10.9181 11.8566 11.1197L11.6711 12H10.1735C10.1735 12 9.92395 11.5 9.92395 11C9.92395 10.6382 9.92395 10.2358 10.0308 10.0798C10.1732 9.87185 10.3513 9.67962 10.5649 9.50315C10.7786 9.32038 11.0084 9.14391 11.2545 8.97374C11.5005 8.80357 11.7304 8.6208 11.944 8.42542C12.1577 8.22374 12.3357 7.99685 12.4782 7.74475C12.6206 7.49265 12.6918 7.19643 12.6918 6.85609C12.6918 6.6292 12.6465 6.42752 12.5559 6.25105C12.4717 6.06828 12.3519 5.91387 12.1965 5.78781C12.0411 5.65546 11.8534 5.55462 11.6332 5.48529C11.4196 5.41597 11.1865 5.3813 10.934 5.3813C10.5649 5.3813 10.2509 5.42227 9.99193 5.5042C9.73942 5.57983 9.52252 5.66807 9.34124 5.76891C9.16642 5.86344 9.01751 5.95168 8.89449 6.03361C8.77147 6.10924 8.66141 6.14706 8.56429 6.14706C8.3312 6.14706 8.16286 6.05252 8.05927 5.86345L7.428 4.88971ZM9.42476 15.005C9.42476 14.799 9.461 14.603 9.53349 14.4169C9.61257 14.2309 9.71801 14.0714 9.84981 13.9385C9.9882 13.8056 10.1497 13.6993 10.3342 13.6196C10.5187 13.5399 10.7164 13.5 10.9273 13.5C11.1316 13.5 11.326 13.5399 11.5105 13.6196C11.695 13.6993 11.8532 13.8056 11.985 13.9385C12.1168 14.0714 12.2222 14.2309 12.3013 14.4169C12.3804 14.603 12.4199 14.799 12.4199 15.005C12.4199 15.2176 12.3804 15.4169 12.3013 15.603C12.2222 15.7824 12.1168 15.9385 11.985 16.0714C11.8532 16.2043 11.695 16.3073 11.5105 16.3804C11.326 16.4601 11.1316 16.5 10.9273 16.5C10.7164 16.5 10.5187 16.4601 10.3342 16.3804C10.1497 16.3073 9.9882 16.2043 9.84981 16.0714C9.71801 15.9385 9.61257 15.7824 9.53349 15.603C9.461 15.4169 9.42476 15.2176 9.42476 15.005Z' fill='#E55A00'/>
      </svg>
      ${tooltip(label, text, position)}
      <span>${label}</span>
    </div>
  `;
  //Hide the help icon & tooltip if the export modal is open to remove these from exported image
  const displayLabelWithoutIcon = `
    <div class='${styles.quadrantLabel}'>      
      <span>${label}</span>
    </div>
  `;
  if (isExportModalOpen) {
    return displayLabelWithoutIcon;
  }
  return displayLabel;
}

export function leftIconLabel(label: string, text: string, position: TooltipPosition, isExportModalOpen: boolean) {
  return iconLabel(HelpIconPosition.LEFT, label, text, position, isExportModalOpen);
}

export function rightIconLabel(label: string, text: string, position: TooltipPosition, isExportModalOpen: boolean) {
  return iconLabel(HelpIconPosition.RIGHT, label, text, position, isExportModalOpen);
}
